import React from 'react';
import { Car, CheckCircle, Users, Clock, ChevronRight, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const LocationVoitureUber = () => {
  const phoneNumber = "0650972620";
  const telLink = "tel:+33650972620";

  const handleCallClick = (e) => {
    if (window.innerWidth >= 768) {
      e.preventDefault();
      alert(`Appelez-nous au ${phoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5')}`);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-black/90 backdrop-blur-sm z-50 border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center space-x-2">
              <Car className="w-8 h-8 text-green-500" />
              <span className="text-xl font-bold">Location VTC Île-de-France</span>
            </Link>
            <div className="flex items-center gap-3">
              <a 
                href={telLink} 
                onClick={handleCallClick}
                className="hidden sm:inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 px-6 py-2 rounded-full font-semibold transition"
              >
                <Phone className="w-4 h-4" />
                Appeler
              </a>
              <Link to="/#contact" className="bg-white/10 hover:bg-white/20 px-6 py-2 rounded-full font-semibold transition border border-white/20">
                Contact
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Floating Call Button (Mobile Only) */}
      <a
        href={telLink}
        className="sm:hidden fixed bottom-6 right-6 z-40 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all hover:scale-110 flex items-center justify-center"
        aria-label="Appeler maintenant"
      >
        <Phone className="w-6 h-6" />
      </a>

      {/* Hero */}
      <section className="pt-32 pb-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Location Voiture <span className="text-green-500">Uber</span> en Île-de-France
          </h1>
          <p className="text-lg sm:text-xl text-gray-300 mb-8">
            Louez un véhicule Toyota C-HR hybride pour travailler avec Uber en toute sérénité
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 px-4 bg-gray-900">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-invert max-w-none">
            <h2 className="text-3xl font-bold mb-6 text-white">Location voiture Uber : La solution pour les chauffeurs</h2>
            <p className="text-gray-300 text-lg mb-6">
              Vous souhaitez devenir chauffeur Uber ou vous êtes déjà en activité et cherchez une <strong>location voiture Uber</strong> fiable en Île-de-France ? Notre service de <strong>location VTC</strong> vous propose des Toyota C-HR hybrides parfaitement adaptés aux exigences de la plateforme Uber.
            </p>

            {/* Image */}
            <div className="my-12 rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1760465066570-6c2261f851e6" 
                alt="Voiture pour Uber"
                className="w-full h-96 object-cover"
              />
            </div>

            <h3 className="text-2xl font-bold mb-4 text-white mt-12">Pourquoi choisir notre location voiture Uber ?</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-8">
              <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700">
                <CheckCircle className="w-10 h-10 text-green-500 mb-4" />
                <h4 className="font-bold text-xl mb-3">Conforme Uber</h4>
                <p className="text-gray-400">Véhicules répondant à tous les critères d'éligibilité Uber : âge, confort, équipements.</p>
              </div>

              <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700">
                <Clock className="w-10 h-10 text-green-500 mb-4" />
                <h4 className="font-bold text-xl mb-3">Disponibilité immédiate</h4>
                <p className="text-gray-400">Récupérez votre véhicule rapidement et commencez à générer des revenus dès aujourd'hui.</p>
              </div>

              <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700">
                <Users className="w-10 h-10 text-green-500 mb-4" />
                <h4 className="font-bold text-xl mb-3">Confort 5 étoiles</h4>
                <p className="text-gray-400">Intérieur premium pour maximiser vos notes et vos pourboires sur Uber.</p>
              </div>

              <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700">
                <Car className="w-10 h-10 text-green-500 mb-4" />
                <h4 className="font-bold text-xl mb-3">Économique</h4>
                <p className="text-gray-400">Hybride pour réduire vos coûts de carburant et augmenter votre rentabilité.</p>
              </div>
            </div>

            <h3 className="text-2xl font-bold mb-4 text-white mt-12">Critères Uber : Notre véhicule est-il éligible ?</h3>
            <p className="text-gray-300 text-lg mb-6">
              Oui ! Le Toyota C-HR que nous proposons en <strong>location voiture Uber</strong> répond à tous les critères de la plateforme :
            </p>
            <ul className="space-y-3 text-gray-300 mb-8">
              <li className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-green-500 mt-1 flex-shrink-0" />
                <span>✓ Véhicule de moins de 10 ans</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-green-500 mt-1 flex-shrink-0" />
                <span>✓ 4 portes minimum</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-green-500 mt-1 flex-shrink-0" />
                <span>✓ 5 places assises</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-green-500 mt-1 flex-shrink-0" />
                <span>✓ Climatisation</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-green-500 mt-1 flex-shrink-0" />
                <span>✓ Bon état général</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold mb-4 text-white mt-12">Combien pouvez-vous gagner avec Uber ?</h3>
            <div className="bg-green-500/10 border border-green-500 rounded-xl p-8 my-8">
              <p className="text-gray-300 mb-4">
                En tant que chauffeur Uber en Île-de-France, vous pouvez générer un revenu attractif. Avec notre <strong className="text-green-500">location voiture Uber</strong> économique, vous maximisez votre rentabilité :
              </p>
              <ul className="space-y-2 text-gray-300">
                <li>• <strong className="text-green-500">Kilométrage illimité</strong> : pas de frais supplémentaires</li>
                <li>• <strong className="text-green-500">Faible consommation</strong> : plus de marge sur chaque course</li>
                <li>• <strong className="text-green-500">Entretien inclus</strong> : pas de mauvaises surprises</li>
              </ul>
            </div>

            <h3 className="text-2xl font-bold mb-4 text-white mt-12">Comment démarrer avec notre location voiture Uber ?</h3>
            <div className="space-y-6 my-8">
              <div className="flex gap-4 items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center border-2 border-green-500">
                  <span className="font-bold">1</span>
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-2">Vérifiez vos documents</h4>
                  <p className="text-gray-400">Carte VTC en cours de validité obligatoire</p>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center border-2 border-green-500">
                  <span className="font-bold">2</span>
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-2">Contactez-nous</h4>
                  <p className="text-gray-400">Remplissez le formulaire de contact</p>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center border-2 border-green-500">
                  <span className="font-bold">3</span>
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-2">Signez le contrat</h4>
                  <p className="text-gray-400">Contrat simple et transparent</p>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center border-2 border-green-500">
                  <span className="font-bold">4</span>
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-2">Récupérez votre véhicule</h4>
                  <p className="text-gray-400">Toyota C-HR prêt à rouler</p>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center border-2 border-green-500">
                  <span className="font-bold">5</span>
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-2">Commencez sur Uber</h4>
                  <p className="text-gray-400">Générez vos premiers revenus immédiatement</p>
                </div>
              </div>
            </div>

            <h3 className="text-2xl font-bold mb-4 text-white mt-12">Également compatible avec Bolt, Heetch et FreeNow</h3>
            <p className="text-gray-300 text-lg mb-6">
              Notre <strong>location voiture Uber</strong> est également parfaitement adaptée pour travailler avec d'autres plateformes VTC comme Bolt, Heetch ou FreeNow. Diversifiez vos sources de revenus !
            </p>

            <div className="bg-gray-800/50 border border-gray-700 rounded-xl p-8 my-12 text-center">
              <h3 className="text-2xl font-bold mb-4">Prêt à devenir chauffeur Uber ?</h3>
              <p className="text-gray-300 mb-6">Louez votre véhicule dès maintenant et commencez à générer des revenus</p>
              <Link to="/#contact" className="inline-flex items-center bg-green-500 hover:bg-green-600 px-8 py-4 rounded-full font-semibold text-lg transition">
                Louer une voiture Uber <ChevronRight className="ml-2" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-8 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <Link to="/" className="inline-flex items-center space-x-2 mb-4">
            <Car className="w-6 h-6 text-green-500" />
            <span className="font-bold">Location VTC Île-de-France</span>
          </Link>
          <p className="text-gray-400 text-sm">
            Location voiture Uber | Location voiture Bolt | Location VTC Île-de-France
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LocationVoitureUber;
